// app Config
(function (angular, app) {
    "use strict";

    angular.module(app.modules.app.name).config(appConfig);

    appConfig.$inject = ["$compileProvider", "$injector", "$provide", "$sceDelegateProvider", "$sceProvider"];

    function appConfig($compileProvider, $injector, $provide, $sceDelegateProvider, $sceProvider) {

        // Expose the provider injector for decorators.
        $provide.constant('$providerInjector', $injector);

        // Enable html 5 mode
        //$locationProvider.html5Mode(true);

        // Disable debug info for significant performance boost
        $compileProvider.debugInfoEnabled(false);

        // Allow blob urls
        $sceDelegateProvider.resourceUrlWhitelist(['self', /^blob:.*$/]);

        // Temporarily disable because we are having issues with it blocking our media
        $sceProvider.enabled(false);
    }

}(angular, app));